<template>
    <div id="view-comment-upload-modal" class="modal-new hidden">
        <svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <div class="title title-container">
            <img :src="avatar" class="avatar" alt="">
            <span class="username">{{ username }}</span>
            <div class="info-container">
                <span class="filename-placeholder">{{ filename }} - </span>
                <span class="date-placeholder">{{ created_at }}</span>
            </div>
        </div>

        <div class="progress-container" v-show="!image">
            <v-progress-circular class="mx-auto"
                                 indeterminate
                                 color="var(--primary)" size="30" width="3"
            />
        </div>

        <div class="image-container">
            <img v-show="image" :src="imageUrl" id="view-comment-upload-image" class="mb-3">
            <span v-if="prevImageIndex >= 0" @click="prevImage" class="material-icons btn-prev-image">navigate_before</span>
            <!--            <span>{{ currentImageIndex + 1 }} of {{ imagesList.length }}</span>-->
            <span v-if="nextImageIndex <= imagesList.length - 1" @click="nextImage" class="material-icons btn-next-image">navigate_next</span>
        </div>

        <div class="buttons-continer --single-item">
            <button type="button" class="modal-btn --cancel" @click="closeModal">Close</button>
        </div>
    </div>
</template>

<script>
import $ from "jquery";

export default {
    data() {
        return {
            avatar: "#",
            username: '',
            filename: '',
            created_at: '',
            image: null,
            imageUrl: null,
            imagesList: [],
        };
    },
    mounted() {
        this.$root.ViewCommentUploadModal = this;

        $("body").on("keydown", e => {
            if ($(lutify.activeModal).attr("id") !== "view-comment-upload-modal") return;

            if (e.key == "ArrowLeft" || e.keyCode == 37) this.prevImage();
            else if (e.key == "ArrowRight" || e.keyCode == 39) this.nextImage();
        })
    },
    watch: {
        image: function (newImage) {
            this.switchImage(newImage);
        }
    },
    computed: {
        currentImageIndex() {
            return this.imagesList.findIndex(image => image.id == this.image.id)
        },
        nextImageIndex() {
            return this.currentImageIndex + 1;
        },
        prevImageIndex() {
            return this.currentImageIndex - 1;
        }
    },
    methods: {
        async switchImage(newImage) {
            URL.revokeObjectURL(this.imageUrl);
            this.imageUrl = null;

            let storeData = await lutify.fetchImage(newImage);

            if (!lutify.activeModal) {
                setTimeout(() => {
                    this.imageUrl = URL.createObjectURL(storeData.blob);
                }, 200)
            } else {
                this.imageUrl = URL.createObjectURL(storeData.blob);
            }

        },
        nextImage() {
            if (this.nextImageIndex < this.imagesList.length) {
                this.image = this.imagesList[this.nextImageIndex];
            }
        },
        prevImage() {
            if (this.prevImageIndex >= 0) {
                this.image = this.imagesList[this.prevImageIndex];
            }
        },
        closeModal() {
            window.UI.hideModal();
        },
    },
};
</script>

<style lang="scss" scoped>
#view-comment-upload-modal {
    min-width: 60%;
}

.title-container {
    display: grid;
    grid-template-areas: "avatar username" "avatar info";
    grid-template-columns: 35px 1fr;
    grid-column-gap: 10px;
    grid-row-gap: 5px;
}

.avatar {
    grid-area: avatar;
    width: 35px;
    height: 35px;
}

.username {
    grid-area: username;
}

.info-container {
    grid-area: info;
    font-weight: normal;
    font-size: 13px;
}

.progress-container {
    min-height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
}

#view-comment-upload-image {
    max-height: 70vh;
    object-fit: contain;
    margin: 0 auto;
    display: block;
}

.image-container {
    position: relative;
    margin-bottom: 50px;

    .material-icons {
        opacity: 0;
        cursor: pointer;
        font-weight: bold;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    &:hover .material-icons {
        opacity: 1;
    }

    .btn-prev-image {
        left: 10px;
    }

    .btn-next-image {
        right: 10px;
    }
}
</style>
